var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectrical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 46.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Electrical Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 8.4V0h-1.4v8.4h-9V0h-1.4v8.4H28V14l6.4 4.8v6.4H41.6v-6.4L48 14V8.4h-4.5zm3.1 4.9l-5.8 4.4-.6.4v5.7h-4.4v-5.7l-.6-.4-5.8-4.4V9.8h17.2v3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6 12.9h4.8v1.4h-4.8zM35.2 29.6h1.7v8.5c0 4-3.5 7.3-7.7 7.3s-7.7-3.3-7.7-7.3V26.5H20v11.6c0 4.8 4.1 8.7 9.1 8.7s9.1-3.9 9.1-8.7v-8.5H40v-1.4h-4.8v1.4zM23.9 22.8c0-1.5-1.1-2.8-2.5-3.1V8.8C21.4 4 17.3.1 12.3.1S3.2 4 3.2 8.8v17.3H1.5v1.4h4.8v-1.4H4.6V8.8c0-4 3.5-7.3 7.7-7.3S20 4.8 20 8.8v10.9c-1.4.3-2.5 1.6-2.5 3.1 0 1.8 1.4 3.2 3.2 3.2s3.2-1.4 3.2-3.2zm-4.9 0c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8-.8 1.8-1.8 1.8-1.8-.8-1.8-1.8zM4.9 31.1l-1.3-.5-3.6 9h6.3l-3.5 6.2 1.3.6 4.6-8.2H2.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrical);
export default __webpack_public_path__ + "static/media/electrical.fdb7913415847ec28429827357d8d02e.svg";
export { ForwardRef as ReactComponent };